import { apiStudent } from '@/lib/api-manager'
import type { PreviousEducationFormType } from '@/schemas/education/match-courses-schema'

export const saveRequestPreviousEducation = async (
  data?: PreviousEducationFormType,
  requestId?: string
) => {
  if (data) {
    const body = {
      requestId,
      createStep: 'previous_education',
      previousEducationStep: {
        previousEducationName: data.previousCourseName,
        previousInstitutionName: data.previousInstituitionName,
        educationType: data.modality,
        educationLevel: data.educationLevel
      }
    }
    return (await apiStudent.post('v1/requests', body)).data
  }
}
